const rangesClose = (a, b, epsilon = 0.01) => {
  if (!a && !b) return true;
  if (!a || !b) return false;
  return (
    Math.abs(Number(a.from) - Number(b.from)) <= epsilon &&
    Math.abs(Number(a.to) - Number(b.to)) <= epsilon
  );
};

export const createSharedRangeBus = () => {
  let currentRange = null;
  const listeners = new Set();

  const notify = (range, sourceId) => {
    listeners.forEach((listener) => {
      try {
        listener(range, sourceId);
      } catch (_) {}
    });
  };

  return {
    getRange() {
      return currentRange;
    },
    setRange(range, sourceId = null) {
      const normalized =
        range &&
        Number.isFinite(range.from) &&
        Number.isFinite(range.to)
          ? { from: Number(range.from), to: Number(range.to) }
          : null;

      if (rangesClose(currentRange, normalized)) {
        return currentRange;
      }

      currentRange = normalized;
      notify(currentRange, sourceId);
      return currentRange;
    },
    clear(sourceId = null) {
      if (currentRange == null) return null;
      currentRange = null;
      notify(null, sourceId);
      return null;
    },
    subscribe(listener) {
      if (typeof listener !== "function") {
        return () => {};
      }
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
};
